import { createContext, PropsWithChildren, useMemo } from 'react'

import Theme, { ThemeProps } from './Theme'

export type Context = Partial<{
  theme: ThemeProps['theme']
}>

export const ThemeContext = createContext<Context | undefined>(undefined)

const ThemeProvider = ({
  children,
  theme = 'light'
}: PropsWithChildren<Context>) => {
  const contextValue = useMemo(() => ({ theme }), [theme])
  return (
    <ThemeContext.Provider value={contextValue}>
      <Theme theme={theme} />
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
